<template>
  <article class="tregister-caso-especial" :key="keyComp">
    <section class="tregister__section tregister__cases">
      <fieldset>
        <legend>Configuración de cálculos</legend>
        <div class="tregister__wrap">
          <div class="field-radio">
            <div class="field-radio__label">Cálculo de Quinta</div>
            <md-checkbox v-model="ldata.disable5ta">Deshabilitar</md-checkbox>
          </div>

          <div
            class="field-radio"
          >
            <div class="field-radio__label">Asignación familiar</div>
            <md-checkbox v-model="ldata.hasFamilyAssignment"
              >Activar Asignación familiar</md-checkbox
            >
          </div>
          <div
            class="field-radio"
          >
            <div class="field-radio__label">Gratificación</div>
            <md-checkbox v-model="ldata.hasGratification"
              >Asignar Gratificación</md-checkbox
            >
          </div>
          <md-field v-if="ldata.hasGratification">
            <label for="gratificationType">Monto de Gratificación</label>
            <md-select
              v-model="ldata.gratificationType"
              name="gratificationType"
              id="gratificationType"
              required
            >
              <md-option :value="0.5">Media</md-option>
              <md-option :value="1">Completa</md-option>
            </md-select>
          </md-field>
          <div
            class="field-radio"
          >
            <div class="field-radio__label">CTS</div>
            <md-checkbox v-model="ldata.hasCts">Asignar CTS</md-checkbox>
          </div>
          <md-field v-if="ldata.hasCts">
            <label for="ctsType">Monto de CTS</label>
            <md-select v-model="ldata.ctsType" name="ctsType" id="ctsType" required>
              <md-option :value="0.5">Media</md-option>
              <md-option :value="1">Completa</md-option>
            </md-select>
          </md-field>
          <div class="field-radio">
            <div class="field-radio__label">Vacaciones</div>
            <md-checkbox v-model="ldata.hasVacationaccumtype"
              >Activar dias acumulados</md-checkbox
            >
          </div>
          <md-field v-if="ldata.hasVacationaccumtype">
            <label for="vacationAccumType">Días de vacaciones al año</label>
            <md-select
              v-model="ldata.vacationAccumtype"
              name="vacationAccumType"
              id="vacationAccumType"
              required
            >
              <md-option :value="1.25">15 días</md-option>
              <md-option :value="2.5">30 días</md-option>
            </md-select>
          </md-field>
          <div
            class="field-radio"
            v-if="['21', '23', '24', '25'].includes(ldata.pensionSystem)"
          >
            <div class="field-radio__label">Prima de Seguros (Mayores de 65 años)</div>
            <md-checkbox v-model="ldata.disableSpp">Desabilitar</md-checkbox>
          </div>
          <div class="field-radio">
            <div class="field-radio__label">SCTR</div>
            <md-checkbox v-model="ldata.hasSctr">Activar</md-checkbox>
          </div>
          <!-- <div
            class="field-radio"
          >
            <div class="field-radio__label">Turno Nocturno</div>
            <md-checkbox v-model="ldata.hasVacationaccumtype">Activar</md-checkbox>
          </div> -->
        </div>
      </fieldset>
    </section>
    <section class="tregister__section tregister__cases">
      <fieldset>
        <legend>Remuneración y Retención de otras empresas</legend>
        <p class="text-important">
          Nota: esto solo aplica si el empleado trabaja en 2 o más empresas a la vez
        </p>

        <!-- remuneracion otra empresa -->
        <md-field>
          <label>Remuneración de otra empresa</label>
          <span class="md-prefix">S/.</span>
          <md-input
            name="rem"
            id="rem"
            v-model.number="ldata.totalOtherRemunerations"
            required
          ></md-input>
          <!-- <span class="md-error" v-if="!$v.ldata.totalPrevRemunerations.numeric">Campo debe ser numérico</span> -->
        </md-field>

        <!-- retencion otra empresa -->
        <md-field class="getValidationClass($v.ldata.totalOtherRetentions)">
          <label>Retención de otra empresa</label>
          <span class="md-prefix">S/.</span>
          <md-input
            name="ret"
            id="ret"
            v-model.number="ldata.totalOtherRetentions"
            required
          ></md-input>
          <!-- <span class="md-error" v-if="!$v.ldata.totalPrevRetentions.numeric">Campo debe ser numérico</span> -->
        </md-field>
      </fieldset>
    </section>
    <section class="tregister__section tregister__actions" v-if="show">
      <md-button class="md-primary" @click="$emit('close-modal')">Cancelar</md-button>
      <md-button class="md-primary md-raised" @click="saveData">Guardar</md-button>
    </section>
  </article>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "Tregistro-Caso-Especial",
  props: {
    value: Object,
    isHistoric: Boolean,
    historicId: String,
  },
  data() {
    return {
      ldata: {},
    };
  },
  computed: {
    show() {
      return ["owner", "master", "manager"].includes(this.$store.getters.roleIn);
    },
    keyComp() {
      if (this.historicId) return this.historicId;
      return "no-historic-id";
    },
    currentHistoricTregister() {
      return this.$store.state.business.tregisterHistoricActual;
    },
  },
  created() {
    console.log("cassos especiales, create");
    if (this.currentHistoricTregister) {
      this.ldata = this.currentHistoricTregister;
    } else {
      this.ldata = this.value;
    }
  },
  methods: {
    ...mapActions({
      updateTRegister: "updateTRegister",
      getTRegisters: "getTRegisters",
    }),
    async saveData() {
      let res, message;
      if (!this.isHistoric) {
        res = await this.updateTRegister({
          id: this.value.id,
          body: this.ldata,
        });
        message = "T-registro actualizado";
      } else {
        res = await this.$store.dispatch("updateTregistersHistoric", {
          id: this.$store.state.business.currentTRegister,
          fk: this.historicId,
          body: this.ldata,
        });
        message = "T-registro Historico actualizado";
      }
      if (res.status === 200) {
        this.$toasted.success(message, {
          theme: "bubble",
          position: "top-right",
          duration: 1000,
          className: "short-message",
        });
        await this.getTRegisters({
          id: this.$localStorage.get("businessID"),
          state: this.stateLocal,
          page: 1,
        });
        this.$emit("close-modal");
      }
    },
  },
  watch: {
    currentHistoricTregister: function (n, o) {
      if (n) {
        this.ldata = n;
        // console.log(this.ldata, this.value);
        // this.$nextTick(() => {
        //   this.$forceUpdate();
        // })
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}

$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
$b-blue-dark: #c63832;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;

.field-radio {
  // margin: 0 2rem 1rem 24px;
  width: 18rem;
  padding-top: 8px;
  position: relative;
  &__label {
    position: absolute;
    top: 0;
    font-size: 12px;
    color: rgba($b-blue, 0.6);
  }
}
.md-field {
  width: 18rem;
  margin: 4px 0 18px;

  &.md-theme-default {
    label {
      color: rgba($b-blue, 0.6);
      &::after {
        color: $b-orange;
      }
    }
    &::after {
      background-color: #d7dae2;
    }
    &::before {
      background-color: $b-blue;
    }
    &.md-focused {
      label {
        color: $b-blue-dark;
      }
    }

    &.md-invalid {
      label {
        color: $b-orange;
      }
      &::after {
        background-color: $b-orange;
      }
      .md-error {
        color: $b-orange;
      }
    }
  }
}

.tregister-caso-especial {
  padding: 2rem;
  fieldset {
    padding: 1rem;
  }
}

.tregister {
  &__section {
    margin-bottom: 1rem;
  }
  &__wrap {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: center;

    @include mq($md) {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
    }
  }
}
.text-important {
  color: #ff0000;
}
</style>
